// extracted by mini-css-extract-plugin
export default {"lists":"Lists_lists__9pPtE","heading":"Lists_heading__-fP8Q","listLink":"Lists_listLink__JqhSw"};